// reducers/SutraMaster.js

/**
 * Reducer for tracking the current sutra (master) index.
 * @param {number} state - The current sutra index (default: 0).
 * @param {Object} action - Redux action.
 * @returns {number} The updated sutra index.
 */
const initialState = 0;

const sutramasterReducer = (state = initialState, action) => {
  if (action.type === "SET_MASTER") {
    // Sets the current sutra index to the payload value
    return action.payload;
  }
  // Returns the current state for any unrelated action
  return state;
};

export default sutramasterReducer;
